import { TFunction } from '@lyearn/i18n';
import { FilterState } from '@/components/FilterManager/types';
import { getAppliedFilterCount } from '@/components/FilterManager/utils';

export default function getEmptyStateMessage({
  title,
  description,
  filter,
  search,
  t,
}: {
  title: string;
  description: React.ReactNode;
  filter: FilterState;
  search: string;
  t: TFunction;
}) {
  const filterCount = getAppliedFilterCount(filter);
  const isSearchApplied = search.length > 0;

  return {
    title: isSearchApplied
      ? t('Common:EmptyState.NoResultsSearch', { searchText: search })
      : filterCount
      ? t('Common:Design.NoResultsFound', {
          count: filterCount,
        })
      : title,
    description: isSearchApplied
      ? t('Common:EmptyState.NoResultsSearchDescription')
      : filterCount
      ? t('Common:EmptyState.NoResultsFiltersDescription')
      : description,
  };
}
